export { default } from "./sidebarMenuTabsContainer";
